import { RequestConfig } from 'common/types/api'
import { create } from 'domain'


export const TOPUP_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/shrimp-topup' },
  getById: { method: 'GET', url: '/shrimp-topup' },
  getSummary: { method: 'GET', url: '/shrimp-topup/summary' },
  create: { method: 'POST', url: '/shrimp-topup' },
  edit: { method: 'PUT', url: '/shrimp-topup' },
  delete: { method: 'DELETE', url: '/shrimp-topup' },
}

